import { inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { TaskUnavailableHandler } from '@mtm/task-ui-angular';

import { openContentUnavailableDialog } from '../../errors/content-unavailable/content-unavailable-dialog.component';

/** A task deep link (route or `?ctx=`) names a task that is gone: show the generic dialog. */
@Injectable({ providedIn: 'root' })
export class TaskUiUnavailableAdapter extends TaskUnavailableHandler {
  private readonly dialog = inject(Dialog);

  onTaskUnavailable(): void {
    openContentUnavailableDialog(this.dialog);
  }
}
